module.exports = __webpack_public_path__ + "files/6bd0fa5f59f8f3af40a8ef030c3ff3cf.png";